import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { getDocumentsDefaultParams } from '@/features/case-list/actions/getDocuments';
import { DocumentsListRoot } from '@/features/case-list/components/DocumentsListRoot';
import { getDocumentsQueryOptions } from '@/features/case-list/queries/getDocuments';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Admin',
    link: { to: '/admin' },
  },
  {
    label: 'Case Standards',
    link: { to: '/admin/case-standards' },
  },
];

const caseStandardsSearchParams = z.object({
  search: fallback(z.string(), '').default(''),
  page: fallback(z.number(), 0).default(0),
  perPage: fallback(
    z.number(),
    parseInt(getDocumentsDefaultParams.limit)
  ).default(parseInt(getDocumentsDefaultParams.limit)),
  sort: fallback(z.string(), getDocumentsDefaultParams.sort).default(
    getDocumentsDefaultParams.sort
  ),
  orderBy: fallback(z.string(), getDocumentsDefaultParams.orderBy).default(
    getDocumentsDefaultParams.orderBy
  ),
});

export const Route = createFileRoute('/admin/case-standards/')({
  component: CaseStandardsComponent,
  validateSearch: zodValidator(caseStandardsSearchParams),
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  loaderDeps: ({ search }) => ({
    search,
  }),
  loader: async ({ context, deps }) => {
    const { search } = deps;
    await context.queryClient.prefetchQuery(
      getDocumentsQueryOptions({
        offset: String(search.page * search.perPage),
        limit: String(search.perPage),
        sort: search.sort,
        orderBy: search.orderBy,
        search: search.search,
      })
    );
  },
  ssr: false,
  caseSensitive: true,
});

function CaseStandardsComponent() {
  return (
    <>
      <AdminPageContent className="flex flex-col overflow-x-auto">
        <AdminPageHeader breadcrumbItems={breadcrumbItems} />
        <DocumentsListRoot />
      </AdminPageContent>
    </>
  );
}

export default CaseStandardsComponent;
